// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1b208877] .plugin-icon{border-radius:4px;height:20px;width:20px}", ""]);
// Exports
module.exports = exports;
